import ListSearchable from './ListSearchable'

export default ListSearchable
